import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import assets from 'modules/assets'
import * as actions from '../../actions'
import Footer from './Footer'
import * as menuData from 'modules/menu'

class Menu extends Component {
  constructor(props) {
    super(props)
    this.defaultText = {
      P1: 'We are a global community of creators using design, technology and pedagogy to reinvent learning.',
      P2: 'We’re building a new kind of learning environment from the ground up — one that turns students into lifelong learners and, better yet, creative educators.'
    }
    this.state = {
      menuState: false,
      menuUrl: 'menu.md',
      textP1: this.defaultText.P1,
      textP2: this.defaultText.P2,
      onHover: 'home'
    }
  }
  componentDidMount() {
    this.loadMenu()
  }
  toggleMenu = () => {
    this.props.dispatch(actions.token.toggleMenu(!this.state.menuState))
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
    if (!this.state.menuData || (nextProps.menuState !== this.state.menuState)) { this.loadMenu() }
  }
  loadMenu() {
    let { dispatch } = this.props
    let url = assets(this.state.menuUrl) //assets('menu.md')
    // dispatch(actions.token.fetchMenu(url))
  }
  updateText(key) {
    this.setState({ onHover: key })
  }
  close = () => {
    this.toggleMenu()
  }
  style(key, anchor) {
    let baseStyle = 'white-link'
    baseStyle = anchor && (anchor === 'anchor') ? baseStyle + ' sectra-light' : baseStyle

    key = key === 'home' ? '/home' : '/' + key

    let path = window.location.pathname
    switch (path) {
      case '/camp/kohai':
        path = '/kohai'
        break
      case '/camp/sempai':
        path = '/sempai'
        break
      case '/':
        path = '/home'
        break
      default:
        path = path
        break
    }
    let isHome = (path === '/home' && key === '/home')

    console.log(path, key)

    if (isHome) {
      return baseStyle + ' active'
    } else if (!isHome && path.startsWith(key)) {
      return baseStyle + ' active'
    } else {
      return baseStyle
    }

  }
  returnMenu() {
    let menuOptions = menuData.menu()
    return menuOptions && Object.keys(menuOptions).map((key, i) => {
        return (
          <h2 key={key}><b>
            <Link
              to={menuOptions[key].link}
              onClick={this.close}
              onMouseEnter={this.updateText.bind(this, key)}
              className={this.style(key)}>
              { menuOptions[key].display }
            </Link>
            {
              key === 'camps' && (
                <div className="menu-subtitle-wrapper">
                  <h2><Link to="gallery" onClick={this.close} className={this.style('gallery', 'anchor')}>Gallery</Link></h2>
                </div>
              )
              /*
                  <h2><Link to="sempai" onClick={this.close} className={this.style('sempai', 'anchor')}>Sempai</Link></h2>
                  <h2><Link to="kohai" onClick={this.close} className={this.style('kohai', 'anchor')}>Kohai</Link></h2>
              */
            }
          </b></h2>
        )
      }
    )
  }
  render() {
    let menu = <div></div>
    if (this.state.menuState && !this.state.isNavigateGallery) {
      menu = (
        <div className='menu app-body fade-in'>
          <div className="main-grid">
            <ul className="grid group menu-top">
              <li className="grid-small"><span className="close-menu" onClick={this.toggleMenu}>×</span></li>
            </ul>
          </div>
          <div className="main-grid">
            <ul className="grid group menu-options">
              <li className="grid-large">
                { this.returnMenu() }
              </li>
            </ul>
          </div>
        </div>
      )
    }
    return menu
  }
}

Menu.contextTypes = {
}
Menu.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: state.routing.locationBeforeTransitions.pathname.slice(1),
    menuState: state.token.menuState,
    isFetchingMenu: state.token.isFetchingMenu,
    menuData: state.token.menuData,
    isNavigateGallery: state.token.isNavigateGallery
  }
}

export default connect(mapStateToProps)(Menu)



// WEBPACK FOOTER //
// ./src/components/Utils/Menu.js